import React from 'react';
import { StatisticsData } from '../types';

interface StatisticPeriodCellProps {
  statistic: StatisticsData;
}

const StatisticPeriodCell: React.FC<StatisticPeriodCellProps> = ({ statistic }) => {
  return (
    <div className="flex items-center">
      <span className="text-sm">{statistic.period}</span>
    </div>
  );
};

export default StatisticPeriodCell;
